// Project cards
export const PROJECT_GITHUB = 'Github'
export const PROJECT_WEBSITE = 'Project Website'
export const PROJECT_DEMO = 'Demo'

export const projectSection = {
    JavaScript: 0,
    SQL: 1,
    Python: 2,
    Java: 3
}

export const projectTabs = {
    React: 'React/JavaScript',
    SQL: 'SQL',
    Python: 'Python',
    Java: 'Java/C++'
}

// Java/C++ projects 
export const EMPLOYEE_DATABASE = 'Employee Database'
export const EMPLOYEE_DATABASE_DESCRIPTION = 'Built using Java Spring boot, React.js and MySQL, an employee database with the ability to add, view, delete and update employees'
export const EMPLOYEE_DB_GIT_LINK = 'https://github.com/abhay2209/employee_project'
export const EMPLOYEE_DB_IMG = 'employee.png'

export const DATA_STRUCTURES = 'DATA STRUCTURES'
export const DS_DESCRIPTION = 'Consists of assignments done in school, which implements double linked list and Binary Search Trees'
export const DS_GIT_LINK = 'https://github.com/abhay2209/Data-Structures'
export const DS_IMG = 'cCode.png'

export const C_BASICS = 'C++ BASICS'
export const C_BASICS_DESCRIPTION = 'Several assignments demonstrating my knowledge of OOP and algorithms'
export const C_BASICS_GIT_LINK = 'https://github.com/abhay2209/Course-Assignments'
export const C_BASICS_IMG = 'cCode.png'

// Python projects 
export const PACMAN_SEARCH = 'PACMAN SEARCH'
export const PACMAN_SEARCH_DESCRIPTION = 'Solving packman using DFS, BFS and A* Search'
export const PACMAN_SEARCH_GIT_LINK = 'https://github.com/abhay2209/Tracking-Pacman'
export const PACMAN_SEARCH_IMG = 'pacman.png'

export const COVID_PREDICT = 'COVID-19 PREDICTOR'
export const COVID_PREDICT_DESCRIPTION = 'Implemented in three sprints, hyperparameter tuned classifiers on covid-19 data'
export const COVID_PREDICT_GIT_LINK = 'https://github.com/abhay2209/Covid-19-data-mining-software'
export const COVID_PREDICT_IMG = 'covid19Ml.png'

export const ML_PROJECTS = 'ML PROJECTS'
export const ML_PROJECTS_DESCRIPTION = 'Implemented from scratch a Random forest classifier, Lof-outlier detection and K-mode clustering'
export const ML_PROJECTS_GIT_LINK = 'https://github.com/abhay2209/MiniProjects-ML'
export const ML_PROJECTS_IMG = 'miniProjects.jpeg'

export const ANAGRAM_FINDER = 'ANAGRAM FINDER'
export const ANAGRAM_FINDER_DESCRIPTION = 'Finds anagram for a word from a dictionary of words provided'
export const ANAGRAM_FINDER_GIT_LINK = 'https://github.com/abhay2209/Anagram-Problem'
export const ANAGRAM_FINDER_IMG = 'anagram.png'

export const AIRBNB_BOOKER = 'AIRBNB BOOKER'
export const AIRBNB_BOOKER_DESCRIPTION = 'CLI for searching, booking and reviewing a booking on Airbnb'
export const AIRBNB_BOOKER_GIT_LINK = 'https://github.com/abhay2209/Airbnb-booker'
export const AIRBNB_BOOKER_IMG = 'airbnb.jpg'

export const WEB_SERVER = 'WEB SERVER'
export const WEB_SERVER_DESCRIPTION = 'A TCP multihtreaded web server that can respond the client\'s HTTP request with five status codes'
export const WEB_SERVER_GIT_LINK = 'https://github.com/abhay2209/Python-Web-Server'
export const WEB_SERVER_IMG = 'webServer.png'

// SQL Projects
export const POKEDEX = 'POKEDEX'
export const POKEDEX_DESCRIPTION = 'Database for Pokemons where a user can add, update or remove pokemons (PostgreSQL)'
export const POKEDEX_GIT_LINK = 'https://github.com/abhay2209/Tokedex-Database'
export const POKEDEX_PROJECT_LINK = 'https://tokedex.herokuapp.com'
export const POKEDEX_IMG = 'pokedex.jpeg'

export const BUMPER_TANKS = 'BUMPER TANKS'
export const BUMPER_TANKS_DESCRIPTION = 'Multiplayer game developed using NodeJS, PostgreSQL, JavaScript, HTML and CSS'
export const BUMPER_TANKS_GIT_LINK = 'https://github.com/abhay2209/Bumper-Tanks'
export const BUMPER_TANKS_PROJECT_LINK = 'https://bumpertank.herokuapp.com/'
export const BUMPER_TANKS_IMG = 'bumperTanks.png'

// Javascript/React projects
export const ASCII = 'ASCII'
export const ASCII_DESCRIPTION = 'In a team of five, built a game for Fallhack2020 held at SFU (ReactJS)'
export const ASCII_GIT_LINK = 'https://github.com/abhay2209/FallHack2020'
export const ASCII_DEMO_LINK = 'https://drive.google.com/drive/folders/1dm9s_XQ4IaucEuLebqPsVsY6yPivCSQ5'
export const ASCII_IMG = 'fallHack.png'

export const GRADE_CALCULATOR = 'GRADE CALCULATOR'
export const GRADE_CALCULATOR_DESCRIPTION = 'SFU theme based website to calculate grades average and weighted average'
export const GRADE_CALCULATOR_GIT_LINK = 'https://github.com/abhay2209/Grade-Calculator'
export const GRADE_CALCULATOR_PROJECT_LINK = 'https://gradecalculator2209.herokuapp.com"'
export const GRADE_CALCULATOR_IMG = 'gradeCalculator.png'

export const PORTFOLIO = 'My Portfolio'
export const PORTFOLIO_DESCRIPTION = 'A portfolio to showcase my experience and projects (ReactJS)'
export const PORTFOLIO_GIT_LINK = 'https://github.com/abhay2209/Portfolio-React'

export const NOTE_MAKER = 'NOTE MAKER'
export const NOTE_MAKER_DESCRIPTION = 'Lets you perform CRUD operations for notes that are stored in PostgreSQL and needs Docker to run. (ReactJS)'
export const NOTE_MAKER_GIT_LINK = 'https://github.com/abhay2209/Note-Maker'
export const NOTE_MAKER_IMG = 'noteMaker.png'

export const BUDGET_WISE = 'BUDGET WISE'
export const BUDGET_WISE_DESCRIPTION = 'In a group of three built a budget supervising web application where a user can maintain and visualize their monthly expenditure (ReactJS | NodeJS | ElephantSQL)'
export const BUDGET_WISE_GIT_LINK = 'https://github.com/abhay2209/budget-wise-app'
export const BUDGET_WISE_DEMO_LINK = 'https://drive.google.com/file/d/1wxdW2_PCV77b_nWGvqSnlN61Wtla2yhF/view?usp=sharing'
export const BUDGET_WISE_IMG = 'budgetwise.png'

// Contact section
export const email = 'abhayjolly18@gmail.com'
export const address = 'Burnaby, BC'

// Resume points 
export const resumeData = [
    {
        title: "Simon Fraser University",
        bulletPoints: [
        "Bachelor of Applied Science with Distinction, major in Computer Science and concentration in Information Systems",
        "Awarded Entrance Scholarship in Summer 2019 and Open scholarship in Summer 2022, Spring 2023, and Summer 2023",
        "Dean's Honor Roll in Spring 2019 and Spring 2022"
      ]
    },
    {
      title: "Software Developer | Visier Inc. [React, TypeScript, Kotlin, Quarkus, PostgreSQL, Zustand, Tanstack Query]",
      bulletPoints: [
      "Collaborate with teams across different countries to develop a data analytics-driven cloud-based application on Visier's PaaS Alpine, optimizing decision-making for total rewards allocation and employee compensation",
      "Implemented a pivotal stock options feature utilizing REST API, object-oriented programming and client/server architecture knowledge, driving multiple customer acquisitions and product success",
      "Enhanced software quality by authoring comprehensive unit, integration, and end-to-end (E2E) tests, utilizing JUnit and Mockito",
      "Contributed to a winning team in a company-wide hackathon, creating a data model and API explorer for company’s PaaS using React Flow, which is now evolving into a new product"
    ]
  },
    {
        title: "Software Developer | Visier Inc. [Angular | NgRx, TypeScript, Scala, PostgreSQL, Cassandra-DB, RxJs, Play Framework]",
        bulletPoints: [
        "Collaborated on multiple projects, contributing to full-stack development using Angular with Onion architecture in the frontend and Scala with MVC architecture in the backend",
        "Followed secure development life cycle by threat modeling a feature, and developed it from UI to DB schema (PostgreSQL) using technologies like Protobuf and Play Framework for RESTful web services",
        "Created Vacuum tasks for Cassandra DB (non-relational), which improved application performance by 25% for 20k+ customers",
        "Created a macOS menu bar application using Python3 and PyQt5 in a company-wide hackathon, streamlining daily scripts for 200+ developers and earning an honorable mention for innovation"
      ]
    },
    {
        title: "Software Developer Co-op | NETGEAR Inc. [Python, PyQt5, Batch]",
        bulletPoints: [
        "Worked in an Agile environment (XP) to develop a multi-threaded Graphical User Interface (GUI)",
        "Developed the GUI using the MVC architecture and object-oriented programming principles which lets a user perform automated throughput tests on the LTE 5GHz modems",
        "Worked with various network communication concepts (TCP/IP, UDP) to develop the GUI's functionality",
        "Used REST API and Socket programming to develop the required APIs and integrated them with the GUI"
      ]
    },
    {
        title: "Teaching Assistant (UI/UX Design) | Simon Fraser University",
        bulletPoints: [
        "For an upper division Computer Science course – User Interface Design (UI/UX), helped students to understand and apply UI/UX principles in the terms of Spring 2021, Fall 2021, and Fall 2022",
        "Provided guidance to students in using Figma to create high-fidelity prototypes during office hours and moderated lectures with the professor"
      ]
    },
    {
        title: "Web Developer | CJSF Radio 90.1 FM. [JavaScript, Bootstrap, HTML, CSS]",
        bulletPoints: [
        "Developed and deployed a website for a fundraising drive which helped support the radio station",
        "Wrote maintainable and scalable code with the Front-end team to add features to the radio station's website",
        "Collaborated with the Backend, Frontend, and the Mobile development team, to elaborate on new features"
      ]
    },
    {
        title: "Personal Experience",
        bulletPoints: [
        "Created several web applications using ReactJS, NodeJS, and PostgreSQL where Docker, Netlify, and Google Cloud Platform were utilized",
        "Have gained a deep understanding of using REST API, network protocols, and User Interface Design",
        "Collaborated in several teams to create maintainable and scalable projects"
      ]
    }
  ];
